import user from "core/user";
import { useSelector } from "react-redux";
import { PermissionTypes } from "enums";

export const useHasEditContractPermission: () => boolean = () => {
    return useSelector(user.hasPermission(PermissionTypes.EDIT_CONTRACT_DATA));
};
